function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0l2.833 9.167H24l-7.416 5.666L19.416 24 12 18.334 4.584 24l2.832-9.167L0 9.167h9.167L12 0z"
});

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "star.9588f.svg";
export { SvgStar as ReactComponent };